import { Component, OnInit, Input ,ViewChild,ElementRef} from '@angular/core';
import { Version } from '../../../modules/models/version';

import {TranslateService} from 'ng2-translate';
import { WorkConstants } from "../work.const";
import { ProjectsService } from '../services/projects.service';
import { AlertManagerService } from '../../../shared/services/alert-manager.service';

import { Sprint, Story } from '../../models';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
})
export class DocumentComponent implements OnInit {
  @Input() projectId: number;
  documents:any=[];
  workConstants:any =  WorkConstants;

  constructor(
    private projectsService: ProjectsService,
    private alertService: AlertManagerService,
    private translate: TranslateService,) { }

  ngOnInit() {
    //this.getFileExtintion(null);

  }

  loadDocument() {
    this.projectsService.getDocuments(this.projectId).subscribe(
      result => {
        this.documents=result.data;
      }, error => {

      });
  }

  getFileExtintion(fileName):string{
    if(fileName){
      let file = fileName.split('.');
      let extintion=file[file.length-1]
      return extintion;
    }
    return 'other';
  }

  

}



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/document.component.ts